import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    imageNumber: 0,
  },
  mutations: {
    IMAGE_NUMBER (state,n) {
      state.imageNumber = n
    },
  },
})
